import { jsx, jsxs } from "react/jsx-runtime";
import React__default from "react";
import PropTypes from "prop-types";
import { Table as Table$1 } from "@zillow/constellation";
const ALIGNMENTS = {
  left: "left",
  right: "right",
  center: "center"
};
const Table = ({
  columns,
  items,
  headerAppearance,
  rowKeyAccessor,
  ...restProps
}) => /* @__PURE__ */ jsx(Table$1.Responsive, { style: {
  position: "relative"
}, children: /* @__PURE__ */ jsxs(Table$1, { ...restProps, children: [
  /* @__PURE__ */ jsx(Table$1.Header, { appearance: headerAppearance, children: /* @__PURE__ */ jsx(Table$1.Row, { children: columns.map(({
    Header,
    accessor,
    align
  }) => /* @__PURE__ */ jsx(Table$1.HeaderCell, { align, children: Header }, accessor)) }) }),
  /* @__PURE__ */ jsx(Table$1.Body, { children: items.map((item) => /* @__PURE__ */ jsx(Table$1.Row, { children: columns.map(({
    accessor,
    Cell,
    align
  }, colIndex) => {
    const content = Cell ? React__default.createElement(Cell, item, null) : item == null ? void 0 : item[accessor];
    return colIndex === 0 ? /* @__PURE__ */ jsx(Table$1.HeaderCell, { align, children: content }, accessor) : /* @__PURE__ */ jsx(Table$1.Cell, { align, children: content }, accessor);
  }) }, item[rowKeyAccessor])) })
] }) });
Table.propTypes = {
  rowKeyAccessor: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.shape({
    Header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    accessor: PropTypes.string.isRequired,
    Cell: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
    align: PropTypes.oneOf(Object.keys(ALIGNMENTS))
  })).isRequired,
  items: PropTypes.arrayOf(PropTypes.object),
  headerAppearance: PropTypes.string
};
Table.defaultProps = {
  rowKeyAccessor: "id",
  items: [],
  headerAppearance: "light"
};
export {
  ALIGNMENTS,
  Table as default
};
